import { language } from './language'
import { catalogCpfCnpj } from './catalog'

export function formatDocument(document) {
  if (!document) return '---'

  let formattedDocument

  if (language() === 'br' || language() === 'pt-BR') {
    formattedDocument = catalogCpfCnpj(document)
  } else {
    formattedDocument = document
  }

  return formattedDocument
}
